import { useLayoutEffect, useState } from 'react';

import { getString } from '../../../helpers/string-helpers';

const ArticleTOC = ({
  chapterTag, countryGuide, locale, targetClass,
}) => {
  const [tableOfContents, setTableOfContents] = useState([]);
  const [activeChapter, setActiveChapter] = useState([]);

  useLayoutEffect(() => {
    const chapterList = [];
    const observerOptions = { rootMargin: '0px 0px -110px 0px' };

    const contentTag = document?.getElementsByClassName(targetClass);
    const chapters = countryGuide
      ? document.querySelectorAll('[anchorid]')
      : contentTag[0]?.getElementsByTagName(chapterTag);

    // We could determine intersections by the entire section rather than just the target tag.
    // const chapterSections = [...chapters].map((chapter)=>{
    //   return chapter.parentNode
    // })

    if (chapters) {
      const observer = new IntersectionObserver((chapters) => {
        for (const chapter of chapters) {
          chapter.isIntersecting
            ? setActiveChapter(chapter.target.id)
            : //setActiveChapter('')
            null;
        }
      }, observerOptions);

      [...chapters].map((chapter) => {
        const title = countryGuide
          ? chapter.attributes.anchorlabel.value
          // eslint-disable-next-line unicorn/prefer-dom-node-text-content
          : chapter.innerText;
        const slug = countryGuide
          ? chapter.attributes.anchorid.value
          : title
            .toLowerCase()
            .trim()
            .replaceAll(/[^\s\w-]/g, '')
            .replaceAll(/[\s_-]+/g, '-')
            .replaceAll(/^-+|-+$/g, '');

        // eslint-disable-next-line unicorn/prefer-query-selector
        const anchor = document.getElementById(`${slug}-anchor`) || document.createElement('div');

        chapter.id = slug;
        anchor.id = `${slug}-anchor`;
        anchor.classList = ['-top-80 sm:-top-120 relative'];
        chapter.parentNode.insertBefore(anchor, chapter);

        chapterList.push({
          slug: slug,
          title: title,
        });

        observer.observe(chapter);
      });
    }

    setTableOfContents(chapterList);
  }, [setTableOfContents]);

  if (chapterTag && targetClass && tableOfContents) {
    return (
      <div className="ArticleTOC blog-lg:max-w-300">
        <h4
          className="font-body font-bold text-24 leading-34 text-charcoal tracking-0"
        >
          {getString('tocText', locale)}
        </h4>
        <ul className="list-none pl-0">
          {tableOfContents.map((chapter, index) => {
            return (
              <li
                key={`TOC-chapter-${index}`}
                className={`${
                  chapter.slug === activeChapter ? '' : 'border-opacity-10'
                } tracking-25 py-16 border-black border-b-1`}
              >
                <a
                  className={`${
                    chapter.slug === activeChapter ? 'font-bold' : 'opacity-50'
                  } no-underline`}
                  href={`#${chapter.slug}`}
                  onClick={(e) => {
                    if (chapter && e) {
                      e.preventDefault();

                      document
                      // eslint-disable-next-line unicorn/prefer-query-selector
                        .getElementById(`${chapter.slug}-anchor`)
                        .scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  {chapter.title}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  } else {
    console.log(`Error in ArticleTOC : invalid data.\n\nchapterTag: ${chapterTag}\n\ntargetClass: ${targetClass}`);
  }
};

export default ArticleTOC;
